import { type Registry as Services, service } from '@ember/service';
import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import ParityManagerFiltersMarketInfo from 'lumen/models/parity-manager/filters/market-info';
import type { IssueType } from 'lumen/models/parity-manager/issue';

export default class ParityManagerFiltersChannel extends ParityManagerFiltersMarketInfo {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-manager/filters/channel' as const;

  @attr() declare issueType: IssueType[];
  @attr('string') declare name: string;

  @service declare ota: Services['ota'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedName() {
    // @ts-expect-error: Argument of type 'string | null' is not assignable to parameter of type 'string'.
    return this.ota.otaIdToPrettyName(this.id);
  }
}
